import { useContext } from "react";

import { QuestionIcon, V2Button } from "@stacklet/ui";

import { useAnalytics } from "app/contexts";
import { HelpContext } from "app/contexts/HelpContext";

interface HelpButtonProps {
  pageNames: string[];
}

export function HelpButton({ pageNames }: HelpButtonProps) {
  const analytics = useAnalytics();
  const helpContext = useContext(HelpContext);
  const showHelp = (pageNames: string[]) => {
    helpContext.setPageNames(pageNames);
    helpContext.expand();
    analytics.track("Help Opened", { pages: pageNames });
  };

  return (
    <V2Button
      aria-label="open help"
      className="text-legacy-navy-L30"
      onPress={() => showHelp(pageNames)}
      variant="plain"
    >
      <QuestionIcon size={24} />
    </V2Button>
  );
}
